export const SHOW_INFO_NOTIFICATION = 'SHOW_INFO_NOTIFICATION';

export const showInfoNotification = ( message: string ) => ({
    type: SHOW_INFO_NOTIFICATION,
    payload: {
        message,
    }
});